import React from 'react'; // useCallback
import { View } from '@gin-betting/core';
import cd from 'debug';
import { useIntl, WrappedComponentProps, injectIntl } from 'react-intl';

import { AsyncOddButton } from 'modules/betslip/async';
import { TITLES_BY_SPECIFIER } from 'app-constants';
import useMarketTotal from './useMarketTotal';
import { MarketValue } from '../MarketsValue';
import { getOverAndUnderOdds } from '../../../utils';
// import { MarketSelect } from '../MarketSelect';
// import MarketTotalOption from './MarketTotalOption';
// import useMarketRow from '../Markets/useMarketRow';
// import { RenderFunction } from '../MarketSelect/types';
// import { MarketRowToggler } from 'components';
// import { getTotalSpecifier } from '../MarketsValue/utils';
import './MarketTotalRow.scss';

const debug = cd('match-list:components:MarketTotalRow');

interface OwnProps {
    // matchId: string;
    // topMarketId: string;
    selectedMarketId: string;
    // marketType: number;
    value: string;
    // getCustomMarketMatches: () => void;
}

type Props = OwnProps & WrappedComponentProps;

export const MarketTotalRow: React.FC<Props> = props => {
    debug('render', props);

    const {
        intl: { formatMessage },
        value,
        selectedMarketId,
        // getCustomMarketMatches,
        // topMarketId,
        // matchId,
        // marketType,
    } = props;

    // const {
    //     marketIds,
    //     showToggler,
    //     setIsOpen,
    //     onTogglerClick,
    //     isOpen,
    //     outcomes,
    // } = useMarketRow({
    //     matchId,
    //     marketType,
    //     topMarketId,
    //     getSpecifier: getTotalSpecifier,
    //     selectedMarketId,
    //     getCustomMarketMatches,
    // });

    const {
        odds,
        // market
    } = useMarketTotal({ marketId: selectedMarketId });

    // const specifiers = market?.specifiers || [];

    const { over, under } = getOverAndUnderOdds(odds, formatMessage);

    // const renderOptions: RenderFunction = useCallback(
    //     ({ height, onClick }) =>
    //         marketIds.map(marketId => (
    //             <MarketTotalOption
    //                 key={marketId}
    //                 marketId={marketId}
    //                 topMarketId={topMarketId}
    //                 onClick={onClick}
    //                 getSpecifier={getTotalSpecifier}
    //                 height={height}
    //                 outcomes={outcomes}
    //             />
    //         )),
    //     [topMarketId, marketIds, outcomes]
    // );

    return (
        <React.Fragment>
            <div styleName="row bg" className="__app-MarketTotal-row ">
                <MarketTotalTitle over={over} under={under} />
            </div>
            <div styleName="row section" className="__app-MarketTotal-row ">
                <MarketValue value={value} />
                {/* {false && showToggler && (
                    <MarketRowToggler onClick={onTogglerClick} rotate={true} />
                )} */}
                <div styleName="col button bg">
                    <AsyncOddButton oddId={over.id} showResult={true} />
                </div>
                <div styleName="col button bg">
                    <AsyncOddButton oddId={under.id} showResult={true} />
                </div>

                {/* {false && isOpen && (
                    <MarketSelect
                        allMarketsIds={marketIds}
                        selectedMarketId={selectedMarketId}
                        title={<MarketTotalTitle over={over} under={under} />}
                        render={renderOptions}
                        onTogglerClick={setIsOpen}
                    />
                )} */}
            </div>
        </React.Fragment>
    );
};

type TitleProps = {
    over: Pick<View.Odd, 'id' | 'name'>;
    under: Pick<View.Odd, 'id' | 'name'>;
};

const MarketTotalTitle: React.FC<TitleProps> = ({ over, under }) => {
    const { formatMessage } = useIntl();
    const title = formatMessage(TITLES_BY_SPECIFIER.total);

    return (
        <React.Fragment>
            <div
                styleName="col title market-type"
                className="__app-MarketTotalTitle-col"
                title={title}
            >
                <span>{title}</span>
            </div>
            <div
                styleName="col title"
                className="__app-MarketTotalTitle-col"
                title={over.name}
            >
                {over.name}
            </div>
            <div
                styleName="col title"
                className="__app-MarketTotalTitle-col"
                title={under.name}
            >
                {under.name}
            </div>
        </React.Fragment>
    );
};

export default injectIntl(MarketTotalRow);
